import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { WasherModel } from '../../../models';
import { DataService } from 'src/app/services/data.service';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-washers',
    templateUrl: './washers.component.html',
    styleUrls: ['./washers.component.scss'],
    standalone: false,
})
export class WashersComponent {
    @Input()
    set boltType(value: string) {
        this._boltType = value;
        this.getWasherDimensions();
    }
    get boltType(): string {
        return this._boltType;
    }

    @Input()
    set boltSize(value: number) {
        this._boltSize = value;
        this.getWasherDimensions();
    }
    get boltSize(): number {
        return this._boltSize;
    }

    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;
        this.getWasherDimensions();
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set pipeSizeId(value: string) {
        this._pipeSizeId = value;
        this.getWasherDimensions();
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }
    @Input() form: UntypedFormGroup;

    tooltip_position = 'above';
    loading: boolean = false;
    washerList: WasherModel[];

    private _boltType: string;
    private _boltSize: number;
    private _pressureClassId: string;
    private _pipeSizeId: string;
    destroy$ = new Subject();
    constructor(
        private iceapi: IceapiService,
        private user_utility: UserUtilityService,
        private dataService: DataService,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        this.form
            .get('enableAdvOp')
            ?.valueChanges?.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.getWasherDimensions();
                }
            });
        if (this.form.get('enableAdvOp')?.value && !this.washerList?.length) {
            this.getWasherDimensions();
        }
    }

    getWasherDimensions(): void {
        // this.form.get('washer').setValue(0);
        const boltType = this.form.get('boltType')?.value || this.boltType;
        if (this.boltSize !== undefined || (boltType != undefined && this.pressureClassId !== undefined && this.pipeSizeId !== undefined)) {
            this.loading = true;
            this.iceapi
                .getWasherDimensions(boltType, this.pressureClassId, this.pipeSizeId, this.boltSize)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .subscribe((washers) => {
                    if (washers.success === true) {
                        this.washerList = washers.response;
                        if (
                            this.dataService?.calculationData?.input?.recordId?.washerDimensionId &&
                            this.washerList.some((washer) => washer.washerDimensionId === this.dataService.calculationData.input.recordId.washerDimensionId)
                        )
                            this.form.get('washer').setValue(this.dataService?.calculationData?.input?.recordId?.washerDimensionId);
                        else {
                            this.form.get('washer').setValue(0);
                        }
                        if (this.washerList.length === 1) this.form.get('washer').setValue(this.washerList[0].washerDimensionId);
                    } else {
                        this.user_utility.errorModelPopup(washers.message);
                    }
                });
        }
    }
}
